import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import { SwitchTransition } from 'react-transition-group';
import { createPortal } from 'react-dom';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import useBodyScrollLock from '../../hooks/useBodyScrollLock';
import { setShowGroupBooking } from '../../appSlice';
import GroupModalStep1 from './GroupModalStep1';
import GroupModalStep2 from './GroupModalStep2';
import { pushEvent } from '../../utilities/analytics';
import { GROUP_BOOKING_TUTORIAL_1, GROUP_BOOKING_TUTORIAL_2 } from '../../constants/analyticEvents';
// import { t } from '../../utilities/translator';


const GroupBookingModal = () => {
  const [currentStep, setCurrentStep] = useState('gb-step-1');
  const dispatch = useDispatch();
  const modalBodyRef = useRef(null);
  const showGroupBookingModal = useSelector((state) => state.app.showGroupBookingModal);

  useOnClickOutside(modalBodyRef, () => dispatch(setShowGroupBooking(false)));
  useBodyScrollLock({ condition: showGroupBookingModal, mobileOnly: false });

  useEffect(() => {
    if (!showGroupBookingModal) {
      setCurrentStep('gb-step-1');
    }
  }, [showGroupBookingModal]);

  useEffect(() => {
    if (showGroupBookingModal) {
      if (currentStep === 'gb-step-1') {
        pushEvent(GROUP_BOOKING_TUTORIAL_1);
      } else if (currentStep === 'gb-step-2') {
        pushEvent(GROUP_BOOKING_TUTORIAL_2);
      }
    }
  }, [currentStep, showGroupBookingModal]);

  const moveToStep1 = () => {
    setCurrentStep('gb-step-1');
  };
  const moveToStep2 = () => {
    setCurrentStep('gb-step-2');
  };


  if (!document.getElementById('modal-portal')) {
    return null;
  }

  return createPortal(
    <CSSTransition
      in={showGroupBookingModal}
      timeout={300}
      classNames="group-booking-animate"
      unmountOnExit
      mountOnEnter
    >
      <div className="group-booking-popup-overlay">
        <div className="group-booking-popup modal-body flex flex-col" ref={modalBodyRef}>
          <div className="close-modal" onClick={() => dispatch(setShowGroupBooking(false))}>
            <i className="ri-close-line text-xl leading-none" />
          </div>
          <div className="flex flex-col group-booking-modal-content">
            <SwitchTransition type="out-in">
              <CSSTransition
                key={currentStep}
                timeout={300}
                classNames="fade-in-switch-animation"
              >
                <>
                  {currentStep === 'gb-step-1' && (
                    <GroupModalStep1
                      nextClick={moveToStep2}
                    />
                  )}
                  {currentStep === 'gb-step-2' && (
                    <GroupModalStep2
                      nextClick={() => dispatch(setShowGroupBooking(false))}
                      backClick={moveToStep1}
                    />
                  )}
                </>
              </CSSTransition>
            </SwitchTransition>
          </div>
        </div>
      </div>
    </CSSTransition>,
    document.getElementById('modal-portal')
  );
};

export default GroupBookingModal;
